module.exports = __webpack_public_path__ + "img/google.a80f94d0.svg";